import React     from 'react';
import PropTypes from 'prop-types';
import Option    from './TransformingSelect/Option';

class TransformingSelect extends React.Component {

	UNSAFE_componentWillMount() {
		this.onSelectChanged = this.onSelectChangedHandler.bind(this);
	}

	/**
	 * @param {String|Number|Object} value
	 * @return {boolean}
	 */
	isSelected(value) {
		if (typeof value === 'object') {
			if (typeof this.props.selected !== 'object') {
				return value.key === this.props.selected;
			}

			let i = 0;

			for (; i < Object.keys(this.props.selected).length; i++) {
				if (this.props.selected[i].key === value.key) {
					return true;
				}
			}
		} else {
			if (typeof this.props.selected !== 'object') {
				return value === this.props.selected;
			}

			let i = 0;

			for (; i < Object.keys(this.props.selected).length; i++) {
				if (this.props.selected[i].key === value) {
					return true;
				}
			}
		}

		return false;
	}

	/**
	 * @param {Event} e
	 * @return {*}
	 */
	onSelectChangedHandler(e) {
		return this.props.onChange(e.target.value);
	}

	render() {
		const values = [];
		const options = this.props.options.map((o, k) => {
			const isScalar = ['string', 'number'].indexOf(typeof o) !== -1;
			const value    = isScalar ? o : o.key;
			const label    = isScalar ? o : o.label;
			values.push(value);

			return (
				<Option key={k}
				        value={value}
				        isMobile={this.props.isMobile}
				        onChange={this.props.onChange}
				        isSelected={this.isSelected(o)}
				        label={label}
				        isDisabled={this.props.isDisabled}
				/>
			);
		});

		const selectProps = {
			name:      this.props.name,
			className: this.props.className + (this.props.isMobile ? ' --as-buttons' : ' --as-select'),
		};

		if (!this.props.isMobile) {
			selectProps.onChange = this.onSelectChanged;
		}

		if (!this.props.id.length > 0) {
			selectProps.id = this.props.id;
		}

		return this.props.isMobile ? <div {...selectProps}>{options}</div> : <select defaultValue={this.props.selected || values[0]} {...selectProps}>{options}</select>;
	}
}

const complexItemType = PropTypes.shape({
	key:   PropTypes.string,
	label: PropTypes.string,
});

const optionPropType = PropTypes.oneOfType([
	PropTypes.string,
	PropTypes.number,
	complexItemType,
]);

TransformingSelect.propTypes = {
	name:       PropTypes.string.isRequired,
	onChange:   PropTypes.func.isRequired,
	className:  PropTypes.string,
	id:         PropTypes.string,
	isMobile:   PropTypes.bool,
	isDisabled: PropTypes.bool,
	options:    PropTypes.arrayOf(optionPropType),
	selected:   PropTypes.oneOfType([
		PropTypes.arrayOf(optionPropType),
		PropTypes.string,
		PropTypes.number,
		complexItemType,
	]),
};

TransformingSelect.defaultProps = {
	options:    [],
	selected:   [],
	isMobile:   false,
	isDisabled: false,
	id:         '',
	className:  'transformable-select',
};

export default TransformingSelect;
